import {BaseComponent} from '../base/component.base.js';
import template from './empty-state.template.html';
import styles from './empty-state.styles.css';

export class EmptyStateComponent extends BaseComponent {
    connectedCallback() {
        this.loadTemplate(template, styles);
    }
}

customElements.define('empty-state', EmptyStateComponent);
